module.exports = __webpack_public_path__ + "img/120.4.180c04fe.png";